/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtract the amount saved from the original price, or multiply the price by (1 − discount ÷ 100).`)
};

const es_pct_discount_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resta la cantidad ahorrada del precio original, o multiplica el precio por (1 − descuento ÷ 100).`)
};

const de_pct_discount_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehe den Sparbetrag vom Originalpreis ab, oder multipliziere den Preis mit (1 − Rabatt ÷ 100).`)
};

const nl_pct_discount_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trek het bespaarde bedrag af van de oorspronkelijke prijs, of vermenigvuldig de prijs met (1 − korting ÷ 100).`)
};

const fr_pct_discount_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soustrayez le montant économisé du prix d'origine, ou multipliez le prix par (1 − réduction ÷ 100).`)
};

const it_pct_discount_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottrai l'importo risparmiato dal prezzo originale, oppure moltiplica il prezzo per (1 − sconto ÷ 100).`)
};

const pt_br2_pct_discount_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtraia o valor economizado do preço original, ou multiplique o preço por (1 − desconto ÷ 100).`)
};

const pt_pct_discount_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtraia o valor poupado ao preço original, ou multiplique o preço por (1 − desconto ÷ 100).`)
};

const ja_pct_discount_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元の価格から節約額を引くか、価格に(1 − 割引 ÷ 100)を掛けます。`)
};

const zh_pct_discount_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用原价减去节省金额，或者用价格乘以 (1 − discount ÷ 100)。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_faq2_a", locale)
	if (locale === "en") return en_pct_discount_faq2_a(inputs)
	if (locale === "es") return es_pct_discount_faq2_a(inputs)
	if (locale === "de") return de_pct_discount_faq2_a(inputs)
	if (locale === "nl") return nl_pct_discount_faq2_a(inputs)
	if (locale === "fr") return fr_pct_discount_faq2_a(inputs)
	if (locale === "it") return it_pct_discount_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_faq2_a(inputs)
	if (locale === "pt") return pt_pct_discount_faq2_a(inputs)
	if (locale === "ja") return ja_pct_discount_faq2_a(inputs)
	return zh_pct_discount_faq2_a(inputs)
};